import React from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';
import { INFOBOX_VARIANT, SIZE, VARIANT } from '@motorway/mw-highway-code/enums';

import { ProfilingInfoBox } from '../ProfilingInfoBox/ProfilingInfoBox';
import { handleRefresh } from '../VehicleProfiling.hooks';
import LocalTexts from '../VehicleProfilingTexts.json';

import styles from './BlockWithImages.module.scss';

const LocalT = new MDText(LocalTexts);

export const PhotosErrorBlock = () => (
  <div className={styles.errorWrapper}>
    <ProfilingInfoBox showConstantly
      heading={{ content: LocalT.translate('confirmDetails.error.title') }}
      variant={INFOBOX_VARIANT.ERROR}
    >
      {LocalT.translate('confirmDetails.error.content')}

      <div className={styles.errorButtonWrapper}>
        <Button label={LocalT.translate('confirmDetails.error.button')} onClick={handleRefresh} size={SIZE.SMALL} variant={VARIANT.SECONDARY} />
      </div>
    </ProfilingInfoBox>
  </div>
);
